export default "__VITE_ASSET__DnQ2Z8DD__"